import { render, staticRenderFns } from "./ContentViewSettingsActionSettings.vue?vue&type=template&id=78974690&scoped=true&"
import script from "./ContentViewSettingsActionSettings.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsActionSettings.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsActionSettings.vue?vue&type=style&index=0&id=78974690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78974690",
  null
  
)

export default component.exports